import(/* webpackMode: "eager", webpackExports: ["HeaderHome"] */ "/vercel/path0/src/components/HeaderHome.tsx");
